package ai.jessie.web.pages.organisations

import ai.jessie.web.customers.CustomerBillingState
import ai.jessie.web.customers.LocalCustomerPort
import ai.jessie.web.customers.customerBilling
import ai.jessie.web.onboarding.organisationRequiredProblem
import ai.jessie.web.onboarding.validOrganisationId
import ai.jessie.web.theme.appFrame
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.isExporting

// UC-012 A3. Tenant state is keyed by the routed organisation, so a change of organisation
// discards it.
@Page("{organisationId}/customer-billing")
@Composable
fun organisationCustomerBillingPage(ctx: PageContext) {
    val organisationId = ctx.route.dynamicParams["organisationId"].orEmpty()
    if (!validOrganisationId(organisationId)) {
        customerProblemFrame(organisationId, organisationRequiredProblem(), BILLING_TITLE)
    } else key(organisationId) { billingContent(organisationId) }
}

@Composable
private fun billingContent(organisationId: String) {
    val port = LocalCustomerPort.current
    val scope = rememberCoroutineScope()
    val model =
        remember(port, scope, organisationId) { CustomerBillingState(port, scope, organisationId) }
    LaunchedEffect(model) { if (!AppGlobals.isExporting) model.refresh() }
    appFrame(
        organisationId,
        customersHref(organisationId),
        BILLING_TITLE,
        authenticationRequired = model.state.error?.authenticationRequired == true,
    ) {
        customerBilling(organisationId, model.state, model::refresh)
    }
}

private const val BILLING_TITLE = "Rechnungsangaben der Kunden (nur lesen)"
